// needed for microfrontend components to load correctly
import("./bootstrap.js");